module.exports = __webpack_public_path__ + "img/air.7779f849.svg";